module.exports = __webpack_public_path__ + "static/media/Rewards.a5ddeded.png";